import { render } from "./Footer.vue?vue&type=template&id=305a3f1d&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=305a3f1d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kyleb\\OneDrive\\Documenten\\Tess website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305a3f1d"]])

export default __exports__